<template>
  <div id="app" class="app">
    <cv-toast-notification  v-show="mostra_avviso" style="position: absolute; top: 3rem; right: 0; z-index: 5"
                           kind="info"
                           title="Conto Terzi in Cloud"
                           sub-title="Lavori in corso"
                           caption="Questa funzionalità sarà implementata appena possibile"
                           :low-contrast="false"
                           @close="togli_avviso()" />

    <cv-header aria-label="Carbon header">
      <cv-header-menu-button aria-label="Header menu" aria-controls="side-nav" />
      <cv-skip-to-content href="#main-content">
        Skip to content
      </cv-skip-to-content>
      <cv-header-name href="javascript:alert('Conto Terzi è un programma di Paolo Proni')" prefix="">
        Conto Terzi
      </cv-header-name>
      <MenuAlto/>

      <!-- Non si può mettere un template subito sotto a un altro template, quindi non può andare nel componente -->
      <template v-slot:left-panels v-if="areLeftPanels">
        <!-- L'id di cv-side-nav è riferito nell'aria-controls di cv-header-menu-button, quindi non può andare dentro al componente -->
        <cv-side-nav id="side-nav" fixed>
            <cv-header-side-nav-items>
              <MenuSinistra />
            </cv-header-side-nav-items>
        </cv-side-nav>
      </template>

      <!-- Icone in alto a destra -->
      <template slot="header-global" >
        <cv-header-global-action aria-label="Ricerche" @click="avvisa()">
          <search20 />
        </cv-header-global-action>
        <cv-header-global-action aria-label="Cambia Terzista" @click="avvisa()">
          <Spine20 />
        </cv-header-global-action>
        <cv-header-global-action aria-label="Help in linea" @click="avvisa()">
          <help20 />
        </cv-header-global-action>
        <cv-header-global-action aria-label="Utente" @click="avvisa()">
          <UserAvatar20 />
        </cv-header-global-action>
      </template>
    </cv-header>

    <RouterView v-on:bottone-premuto="avvisa()">
    </RouterView>

  </div>
</template>

<script>
import MenuAlto from "@/components/menu/MenuAlto";
import MenuSinistra from "@/components/menu/MenuSinistra";

import Search20 from "@carbon/icons-vue/es/search/20";
import Spine20 from "@carbon/icons-vue/es/watson-health/spine-label/20";
import Help20 from "@carbon/icons-vue/es/help/20";
import UserAvatar20 from "@carbon/icons-vue/es/user--avatar/20";

export default {
  name: 'App',
  components: {
    MenuAlto,
    MenuSinistra,
    Search20,
    Spine20,
    Help20,
    UserAvatar20
  },
  data: function() {
    return {
      mostra_avviso: false,
      areLeftPanels: true
    }
  },
  methods:  {
    avvisa: function () {
      window.scrollTo(0,0);
      this.mostra_avviso = true;
    },
    togli_avviso: function () {
      this.mostra_avviso = false;
    }
  }
}
</script>

<style lang="scss">
@import "./styles/carbon";

#app {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

// Se togli il padding, sparisce il tag
//  padding: 3rem;
  color: $text-01;
  background-color: $ui-background;
  height: 100vh;
}

</style>